import {
    Configuration,
    CalcceApi,
    CalcapApi,
    Middleware,
    UsersApi,
    FunctionApi,
    CoefficientApi,
    FetchParams,
    HTTPMethod,
    RequestContext
  } from './generated-rest-client';
    
  const requestLogger: Middleware = {
    pre: async (context) => {
      console.log(`>> ${context.init.method} ${context.url}`, context.init);
    },
    post: async (context) => {
      console.log(`<< ${context.response.status} ${context.url}`, context.response);
    }
  };
  
  const corsHandler: Middleware = {
    pre: async (context) => {
      return {
        url: context.url,
        init: {
          ...context.init,
          mode: 'cors',
          credentials: 'include'
        }
      };
    }
  };
  
  class CsrfTokenAttachment implements Middleware {
  
    private readonly targetMethod: ReadonlyArray<HTTPMethod> = ['POST', 'PUT', 'DELETE', 'PATCH'];
    private headerName = '';
    private tokenValue = '';
  
    setCsrfToken(headerName: string, tokenValue: string) {
      console.log('setCsrfToken:', headerName, tokenValue);
      this.headerName = headerName;
      this.tokenValue = tokenValue;
    }
  
    pre = async (context: RequestContext): Promise<FetchParams | void> => {
      if (!this.headerName || !this.targetMethod.includes(context.init.method as HTTPMethod)) {
        return;
      }
      console.log('attach csrf token:', this.headerName, this.tokenValue);
      return {
        url: context.url,
        init: {
          ...context.init,
          headers : {
            ...context.init.headers,
            [this.headerName]: this.tokenValue
          }
        }
      };
    }
  }
  
  const csrfTokenAttachment = new CsrfTokenAttachment();
  
  const configuration = new Configuration({
    middleware: [csrfTokenAttachment, corsHandler, requestLogger],
    basePath: process.env.REACT_APP_API_ENDPOINT
//    middleware: [requestLogger]
  });
  
  const calcceApi = new CalcceApi(configuration);
  
  const calcapApi = new CalcapApi(configuration);
  
  const usersApi = new UsersApi(configuration);

  const functionApi = new FunctionApi(configuration);

  const coefficientApi = new CoefficientApi(configuration);
  
  const login = async (idToken: string) => {
    return usersApi.postLogin({ postLoginRequest: { idToken }});
  };
  
  const postCalcce = async (idToken: string, multipartFile: File, coefficientSetId: string) => {
    return calcceApi.postCalcce({ idToken, multipartFile, coefficientSetId });
  };

  const availableFunction = async (idToken: string) => {
    console.log('availableFunction idToken :=' + idToken);
    return functionApi.postFunction({ postLoginRequest: { idToken } });
  };
  
  const postCalcap = async (idToken: string, multipartFile: File) => {
    return calcapApi.postCalcap({ idToken, multipartFile });
  };
  
  const refreshCsrfToken = async () => {
    const response = await usersApi.getCsrf();
    csrfTokenAttachment.setCsrfToken(response.headerName, response.token);
  };

  const availableCoefficientSet = async (idToken: string) => {
    console.log('availableCoefficient idToken :=' + idToken);
    return coefficientApi.postAvailableCoefficientSet({ postLoginRequest: { idToken } });
  };
  
  export const BackendService = {
    login,
    availableFunction,
    postCalcce,
    postCalcap,
    refreshCsrfToken,
    availableCoefficientSet
  };
